module.exports = __webpack_public_path__ + "static/picwords-selection-sketch-c78adbef6d60618b6d82851ccdb89c5f.png";